import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
export const id_enrollmentCSPProvider = "1.3.6.1.4.1.311.13.2.2";
export class CSPProvider {
    constructor(params = {}) {
        this.keySpec = 0;
        this.cspName = "";
        this.signature = new ArrayBuffer(0);
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], CSPProvider.prototype, "keySpec", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.BmpString })
], CSPProvider.prototype, "cspName", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.BitString })
], CSPProvider.prototype, "signature", void 0);
